/*
 * @author Adrian Nitu <adrian.nitu at gmail.com>
 * @version 0.1 - 2017-05-11
 */
function UserManagement() {

	var hashes = ['login', 'register', 'recover', 'account', 'change'];
	var modalIds = [];
	var ajaxLogin, ajaxRegister, ajaxRecover, ajaxChange;
	var _nextModalId;

	function init(){
		hashes.forEach(function(item, idx){
			modalIds.push("#"+item+"Modal");
		});
		var op = window.location.hash.substr(1);
		var hashId = hashes.indexOf(op);

		$(document).on('show.bs.modal', modalIds.join(), changeHash);
		$(document).on('hidden.bs.modal', modalIds.join(), modalIsClosed);
		$(document).on('click', 'a.openModal', openModal);
		$(document).on('click', 'a.modal-facebook', fbLogin);

		ajaxLogin = new AjaxPostman("form.form_login", loginSuccess, loginFailed);
		ajaxRegister = new AjaxPostman("form.form_register", replaceModalBody, registerFailed);
		ajaxRecover = new AjaxPostman("form.form_reset", replaceModalBody, recoverFailed);
		ajaxChange = new AjaxPostman("form.form_change", replaceModalBody, changePassFailed);

		if(hashId + 1)
			$(modalIds[hashId]).modal('show');
	}
	function fbLogin(e) {
		if(e)
			e.preventDefault();
		if(!window.FB)
			return false;

		FB.login(function (response) {
			if (response.authResponse) {
	//			console.log('You are logged in!', response);
				facebookAjaxLogin($(e.target).attr('href'));
			} else {
	//			console.log('User cancelled login or did not fully authorize.');
			}
		}, {scope: 'email'});
		return false;
	};

	function facebookAjaxLogin(route){
		$.ajax({
			type: 'get',
			url: route,
//			data: $(this).serialize(),
			context: this,
	//			dataType: 'json',
			success: loginSuccess,
			error: function (xhr) {
				console.log(xhr);
			}
		});
	}

	function openModal(e){
		_nextModalId = $(this).data('target');
		if($('.modal.in').length)
			$('.modal.in').modal('hide');
		else {
			$(_nextModalId).modal('show');
			_nextModalId = null;
		}
	}

	function modalIsClosed(e){
		if(_nextModalId)
			$(_nextModalId).modal('show');
		else if(!$('.modal.in').length){
			history.replaceState({}, '', window.location.href.split("#")[0]);
			if (window.ga) {
				ga('send','pageview');
			}
		}
		_nextModalId = null;
	}

	function changeHash(e){
		var hash = e.target.id.replace(/([a-z]+)Modal/, "$1");
		history.replaceState({}, '', window.location.href.split("#")[0]+'#'+hash);
		if (window.ga) {
			ga('send','pageview','/'+hash);
		}
	}

	var replaceModalBody = function (data) {
		$(this).data('submitting', false)
				.removeClass('submitting')
				.parents('.modal-body')
					.html('<h2>'+data+'</h2><p><button type="button" data-dismiss="modal" class="btn btn-home btn-fullwidth btn-upper">OK</button></p>');
		if (window.ga) {
			ga('send','pageview','/'+window.location.href.split("#")[1]+'/success');
		}
	};

	var loginSuccess = function (data) {
		$(this).data('submitting', false)
				.removeClass('submitting');
		$('.modal.in').modal('hide');
		history.replaceState({}, '', window.location.href.split("#")[0]);
		window.location.reload();
	};

	var loginFailed = function (xhr) {
		var $errors = $('.errors', this);
		if (xhr.status == 422) {
			for (var field in xhr.responseJSON) {
				$('*[name=' + field + '], input[name=' + field + ']+label', this)
						.last()
						.parents('.form-group:first').addClass('has-error');
				for (var err in xhr.responseJSON[field])
					$errors.append('<span class="help-block">' + xhr.responseJSON[field][err] + '</span>');
			}
			$('.errors', this).addClass('has-errors').slideDown();
		} else if (xhr.status == 403) {
			$('.errors', this).addClass('has-errors').html("<span class='help-block'>" + xhr.responseText + "</span>").slideDown();
		} else {
			console.log(xhr);
		}
	};

	var registerFailed = function (xhr) {
		var $errors = $('.errors', this);
		if (xhr.status == 422) {
			for (var field in xhr.responseJSON) {
				$('*[name=' + field + '], input[name=' + field + ']+label', this)
						.last()
						.parents('.form-group:first').addClass('has-error');
				for (var err in xhr.responseJSON[field])
					$errors.append('<span class="help-block">' + xhr.responseJSON[field][err] + '</span>');
			}
			$('.errors', this).addClass('has-errors').slideDown();
		} else if (xhr.status == 403) {
			$('.errors', this).addClass('has-errors').html("<span class='help-block'>" + xhr.responseText + "</span>").slideDown();
		} else {
			console.log(xhr);
		}
	};

	var recoverFailed = function (xhr) {
		var $errors = $('.errors', this);
		if (xhr.status == 422) {
			for (var field in xhr.responseJSON) {
				$('*[name=' + field + '], input[name=' + field + ']+label', this)
						.last()
						.parents('.form-group:first').addClass('has-error');
				for (var err in xhr.responseJSON[field])
					$errors.append('<span class="help-block">' + xhr.responseJSON[field][err] + '</span>');
			}
			$('.errors', this).addClass('has-errors').slideDown();
		} else if (xhr.status == 403) {
			$('.errors', this).addClass('has-errors').html("<span class='help-block'>" + xhr.responseText + "</span>").slideDown();
		} else {
			console.log(xhr);
		}
	};

	var changePassFailed = function (xhr) {
		var $errors = $('.errors', this);
		if (xhr.status == 422) {
			for (var field in xhr.responseJSON) {
				$('*[name=' + field + '], input[name=' + field + ']+label', this)
						.last()
						.parents('.form-group:first').addClass('has-error');
				for (var err in xhr.responseJSON[field])
					$errors.append('<span class="help-block">' + xhr.responseJSON[field][err] + '</span>');
			}
			$('.errors', this).addClass('has-errors').slideDown();
		} else if (xhr.status == 403) {
			$('.errors', this).addClass('has-errors').html("<span class='help-block'>" + xhr.responseText + "</span>").slideDown();
			window.location.href = '/#login';
			window.location.reload();
		} else {
			console.log(xhr);
		}
	};


	init();
}
